import { Grid , Typography,Box } from "@mui/material"
import CountUp from 'react-countup';



const CryptoStats = ({data}) => {
  return (
    <Grid item>
    <Grid item container direction="column">
      <Typography align="center" sx={{ fontWeight: 500 }} variant="h4">
        Global Cryptos Stats
      </Typography>
      <Grid item>
        <Grid item container sx={{ mt: 4 }}>
          <Grid item xs={12} sm={6}>
            <Grid
              item
              container
              direction="column"
              alignItems="center"
              rowGap={2}
              sx={{
                background: {
                  xs: "#fff",
                  sm: "transparent",
                },
                mb: {
                  xs: 2,
                  sm: 0,
                },
                borderRadius: {
                  xs: 5,
                  sm: 0,
                },
                boxShadow: {
                  xs: 3,
                  sm: 0,
                },
              }}
            >
              <Grid item>
                <Typography variant="h5">ToTal Cryptocurrencies</Typography>
              </Grid>
              <Grid sx={{ mb: 2 }} item>
                <CountUp
                  start={0}
                  delay={0}
                  end={data?.data?.stats?.total}
                  duration={2}
                >
                  {({ countUpRef }) => (
                    <div>
                      <Box
                        sx={{ fontSize: "2rem", fontWeight: 600 }}
                        ref={countUpRef}
                      />
                    </div>
                  )}
                </CountUp>
              </Grid>
            </Grid>
          </Grid>
          <Grid
            item
            xs={12}
            sm={6}
            sx={{
              background: {
                xs: "#fff",
                sm: "transparent",
              },
              mb: {
                xs: 2,
                sm: 0,
              },
              borderRadius: {
                xs: 5,
                sm: 0,
              },
              boxShadow: {
                xs: 3,
                sm: 0,
              },
            }}
          >
            {" "}
            <Grid
              item
              container
              direction="column"
              alignItems="center"
              rowGap={2}
            >
              <Grid item>
                <Typography variant="h5">ToTal Exchanges</Typography>
              </Grid>
              <Grid sx={{ mb: 2 }} item>
                <CountUp
                  start={0}
                  delay={0}
                  end={+data?.data?.stats?.totalExchanges}
                  duration={2}
                >
                  {({ countUpRef }) => (
                    <div>
                      <Box
                        sx={{ fontSize: "2rem", fontWeight: 600 }}
                        ref={countUpRef}
                      />
                    </div>
                  )}
                </CountUp>
              </Grid>
            </Grid>
          </Grid>
          <Grid
            item
            xs={12}
            sm={6}
            sx={{
              background: {
                xs: "#fff",
                sm: "transparent",
              },
              mb: {
                xs: 2,
                sm: 0,
              },
              borderRadius: {
                xs: 5,
                sm: 0,
              },
              boxShadow: {
                xs: 3,
                sm: 0,
              },
            }}
          >
            {" "}
            <Grid
              item
              container
              direction="column"
              alignItems="center"
              rowGap={2}
            >
              <Grid item>
                <Typography variant="h5">ToTal Marketcap</Typography>
              </Grid>
              <Grid sx={{ mb: 2 }} item>
                <CountUp
                  prefix="$"
                  start={0}
                  delay={0}
                  end={+data?.data?.stats?.totalMarketCap}
                  duration={2}
                >
                  {({ countUpRef }) => (
                    <div>
                      <Box
                        sx={{ fontSize: "2rem", fontWeight: 600 }}
                        ref={countUpRef}
                      />
                    </div>
                  )}
                </CountUp>
              </Grid>
            </Grid>
          </Grid>
          <Grid
            item
            xs={12}
            sm={6}
            sx={{
              background: {
                xs: "#fff",
                sm: "transparent",
              },
              mb: {
                xs: 2,
                sm: 0,
              },
              borderRadius: {
                xs: 5,
                sm: 0,
              },
              boxShadow: {
                xs: 3,
                sm: 0,
              },
            }}
          >
            {" "}
            <Grid
              item
              container
              direction="column"
              alignItems="center"
              rowGap={2}
            >
              <Grid item>
                <Typography variant="h5">ToTal 24h Volume</Typography>
              </Grid>
              <Grid sx={{ mb: 2 }} item>
                <CountUp
                  prefix="$"
                  start={0}
                  delay={0}
                  end={+data?.data?.stats?.total24hVolume}
                  duration={2}
                >
                  {({ countUpRef }) => (
                    <div>
                      <Box
                        sx={{ fontSize: "2rem", fontWeight: 600 }}
                        ref={countUpRef}
                      />
                    </div>
                  )}
                </CountUp>
              </Grid>
            </Grid>
          </Grid>
          <Grid
            item
            xs={12}
            sm={6}
            sx={{
              background: {
                xs: "#fff",
                sm: "transparent",
              },
              mb: {
                xs: 2,
                sm: 0,
              },
              borderRadius: {
                xs: 5,
                sm: 0,
              },
              boxShadow: {
                xs: 3,
                sm: 0,
              },
            }}
          >
            {" "}
            <Grid
              item
              container
              direction="column"
              alignItems="center"
              rowGap={2}
            >
              <Grid item>
                <Typography variant="h5">ToTal Coins</Typography>
              </Grid>
              <Grid item>
                <CountUp
                  start={0}
                  delay={0}
                  end={+data?.data?.stats?.totalCoins}
                  duration={2}
                >
                  {({ countUpRef }) => (
                    <div>
                      <Box
                        sx={{ fontSize: "2rem", fontWeight: 600 }}
                        ref={countUpRef}
                      />
                    </div>
                  )}
                </CountUp>
              </Grid>
            </Grid>
          </Grid>
          <Grid
            item
            xs={12}
            sm={6}
            sx={{
              background: {
                xs: "#fff",
                sm: "transparent",
              },
              mb: {
                xs: 2,
                sm: 0,
              },
              borderRadius: {
                xs: 5,
                sm: 0,
              },
              boxShadow: {
                xs: 3,
                sm: 0,
              },
            }}
          >
            {" "}
            <Grid
              item
              container
              direction="column"
              alignItems="center"
              rowGap={2}
            >
              <Grid item>
                <Typography variant="h5">ToTal Markets</Typography>
              </Grid>
              <Grid sx={{ mb: 2 }} item>
                <CountUp
                  start={0}
                  delay={0}
                  end={+data?.data?.stats?.totalMarkets}
                  duration={2}
                >
                  {({ countUpRef }) => (
                    <div>
                      <Box
                        sx={{ fontSize: "2rem", fontWeight: 600 }}
                        ref={countUpRef}
                      />
                    </div>
                  )}
                </CountUp>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  </Grid>
  )
}

export default CryptoStats